<!-- competition button -->
<ng-container *ngIf="hasCompetitionCta">
  <ng-template [ngTemplateOutlet]="competitionsCtaTemplate"></ng-template>
</ng-container>

<a
  #videoThumbnail
  class="video-thumbnail"
  [class.gradient]="!active"
  [class.playing]="active"
  [class.pointer]="video && channelCarouselImgClickable"
  (click)="onChannelCarouselImg()"
>
  <p-skeleton width="100%" height="100%" position="absolute"></p-skeleton>

  <!-- arrows -->
  <ng-container *ngIf="showArrows">
    <div class="channel-slide-arrows-wrapper">
      <div class="arrow-channel-slide-left left" (click)="prev()">
        <div class="arrow-long"></div>
      </div>
      <div class="arrow-channel-slide-right" (click)="next()">
        <div class="arrow-long"></div>
      </div>
    </div>
  </ng-container>

  <!-- VIDEO EMBED -->
  <ng-container *ngIf="(embed && movie && active) || (video && active)">
    <ush-video
      [style.pointer-events]="embedControls ? 'auto' : 'none'"
      [content]="this.video ? this.video : this.movie"
      [embed]="true"
      [controls]="embedControls"
      [mute]="mute"
      [loop]="loop"
      [autoplay]="autoplay"
      [trackingCategory]="trackingCategory"
      (videoReady)="videoIsReady.next(true)"
      (pausedAtTheEnd)="onEmbeddedVideoPausedAtTheEnd()"
    ></ush-video>
  </ng-container>
  <!-- END VIDEO EMBED -->

  <ng-container *ngIf="(!embed && (movie || video)) || (embed && ((movie && !active) || (video && !active)))">
    <button
      *ngIf="uPlayerPurchased || (videoExists && (movie?.trTrailerLink || video?.trailer || video?.video))"
      class="ctrl-play center"
      [class.uplayer]="uPlayerPurchased"
      [ngStyle]="{ display: shouldShowThumbnailCenterPlayButton ? 'flex' : 'none' }"
      [style]="uPlayerPurchased ? '--text-play-now: \'' + playNowLabel + '\'' : null"
      (click)="requestPlayVideo()"
    >
      <ng-content *ngTemplateOutlet="iconPlayTemplate"></ng-content>
    </button>

    <div class="share-movie" *ngIf="shareMovie">
      <div class="share-links">
        <i class="pi pi-share-alt"></i>
        <ush-movie-tell-friends [movie]="movie"></ush-movie-tell-friends>
      </div>
    </div>

    <!-- see more button -->
    <ng-container
      *ngIf="seeMore && seeMorePos === 'top'"
      [ngTemplateOutlet]="readMore"
      [ngTemplateOutletContext]="{ type: this.seeMoreType ? this.seeMoreType : 1 }"
    ></ng-container>
    <!-- end see more button -->
    <!-- Main Video Thumbnail Tile Image -->
    <img
      *ngIf="!videoMovie"
      [id]="heroVideoThumbnail ? 'heroimg' : ''"
      [ngSrc]="movie ? movie.tilePhotoUrl || landscapePlaceholder : video.thumbnailUrl || landscapePlaceholder"
      [sizes]="
        heroVideoThumbnail ? '100vw' : '(max-width:576px) 100vw, (max-width:992px) 45vw, (max-width: 1200) 30vw, 20vw'
      "
      width="1600"
      height="900"
      [priority]="heroVideoThumbnail ? true : false"
      style="width: 100%; height: auto"
      [alt]="video ? video?.movieTitle : movie?.title + ' thumbnail'"
      (click)="onMoviePicClicked(movie ? movie : null)"
      addSkeleton
    />
    <!-- End Main Video Thumbnail Tile Image -->

    <!-- if there is a video thumbnail (movie.tile or fullPagePhoto) -->
    <img
      *ngIf="videoMovie"
      class="video-movie-img"
      [ngSrc]="video.thumbnailUrl && video.thumbnailUrl !== 'null' ? video.thumbnailUrl : landscapePlaceholder"
      [sizes]="'(max-width:770px) 90vw, 70vw'"
      [priority]="heroVideoThumbnail ? true : false"
      width="1360"
      height="747"
      [alt]="video ? video?.movieTitle : movie?.title + ' thumbnail'"
      (click)="onMovieVideoPicClicked(video)"
    />
  </ng-container>
</a>

<div
  #controls
  *ngIf="!ignoreControls"
  class="controls page-content"
  [class.playing]="active"
  [class.paused]="!playingVideo"
  [class.onResizeInicialited]="onResizeInicialited"
  [class.flatAspectRatio]="controlsVisibleFlatAspectRatio"
>
  <!-- logo-subtitle or title-subtitle -->
  <div class="controls-wrapper">
    <!-- scroll-large-video -->
    <button *ngIf="scrollLargeVideoButonVisible" class="scroll-large-video" (click)="scrollLargeVideo()">
      <div
        class="scroll-large-video-text"
        data-translate="video-thumbnail.scrollForMore"
        i18n="@@video-thumbnail.scrollForMore"
      >
        Scroll for more
      </div>
      <i class="pi pi-angle-down" style="font-size: 2rem"></i>
    </button>

    <div class="inner-wrapper" style="position: relative">
      <!-- logo-subtitle or title-subtitle -->
      <div class="control-header">
        <!-- in case it is a video -->
        <ng-container *ngIf="!ignoreMovie">
          <ng-container *ngIf="isThereLogo(); else titleTemplate">
            <div class="video-thumbnail-logo-wrap">
              <img
                class="video-thumbnail-logo"
                [ngSrc]="customMovieLogo || video?.movieLogoUrl || movie.logoUrl"
                sizes="(max-width:530px) 90vw, (max-width:1000px) 50vw, 30vw"
                height="150"
                width="450"
                style="height: auto"
                priority="true"
                [alt]="video ? video?.movieTitle : movie.trTitle + ' logo'"
              />
            </div>

            <div class="status" *ngIf="video?.subtitle || movie?.releaseMessage">
              <span [innerHTML]="video?.subtitle || movie?.releaseMessage | safe: 'html'"></span>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="control-buttons" [class.playing]="active">
        <ng-container *ngIf="videoExists">
          <ng-container *ngIf="(!embed || forceRegularControls) && !active; else playPauseButtons">
            <!-- Watch trailer button -->
            <button
              class="ctrl-play button control-btn"
              *ngIf="(movie?.trTrailerLink || video?.trailer || video?.video !== 'null') && !shouldUseCenteredYoutubePlayButton"
              (click)="requestPlayTrailer()"
            >
              <ng-content *ngTemplateOutlet="iconPlayTemplate"></ng-content>
              <span data-translate="movie-template-a.menu.watchTrailer" i18n="@@movie-template-a.menu.watchTrailer"
                >Watch</span
              >
            </button>
            <!-- Watch Now button for movies with full videos -->
            <ng-container *ngIf="movie?.fullVideoUrl">
              <a class="ctrl-see-more ctrl-see-more-1" (click)="handleCtaClick()">
                <button
                  class="ctrl-detail control-btn button-secondary"
                  data-translate="movie.cta.watchNow"
                  i18n="@@movie.cta.watchNow"
                >
                  Watch at home
                </button>
              </a>
            </ng-container>
            <!-- End Watch now button -->
          </ng-container>
        </ng-container>
        <!-- Watch now button for videoMovies that has fullVideo -->
        <ng-container *ngIf="videoMovie && hasFullVideo">
          <a class="ctrl-see-more ctrl-see-more-2" (click)="handleCtaClick()">
            <button class="ctrl-detail control-btn button-secondary">
              {{ 'movie-template-a.menu.' + (video.cta | cammelCase) }}
            </button>
          </a>
        </ng-container>
        <!-- End Watch now button for video movies -->
        <ng-container *ngIf="video?.cta && !videoMovie">
          <a
            class="ctrl-see-more ctrl-see-more-3"
            [routerLink]="getCtaRouterLink()"
            [queryParams]="getCtaLinkParams(video?.ctaUrl)"
            [state]="getCtaLinkState()"
            [externalLink]="isExternalLink ? getCtaRouterLink() : ''"
            (click)="handleCtaClick()"
          >
            <button class="ctrl-detail control-btn button-secondary">
              {{ 'movie-template-a.menu.' + (video.cta | cammelCase) }}
            </button>
          </a>
        </ng-container>
        <ng-container
          *ngIf="seeMorePos === 'middle'"
          [ngTemplateOutlet]="readMore"
          [ngTemplateOutletContext]="{ type: this.seeMoreType ? this.seeMoreType : 1 }"
        ></ng-container>
        <ush-uplay-button
          *ngIf="hasUplayer"
          [movie]="movie"
          [triggerPlay]="triggerUplayerPlay"
          (purchased)="handleUplayPurchased($event)"
        ></ush-uplay-button>
        <ng-container *ngIf="extraControlsContent?.length > 0">
          <ng-container *ngFor="let content of extraControlsContent">
            <ng-template [ngTemplateOutlet]="content"></ng-template>
          </ng-container>
        </ng-container>
        <ng-container
          *ngIf="seeMorePos === 'buttons'"
          [ngTemplateOutlet]="readMore"
          [ngTemplateOutletContext]="{ type: this.seeMoreType ? this.seeMoreType : 1 }"
        ></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #titleTemplate>
  <div class="bold video-thumbnail-title">{{ movie?.title || video?.title }}</div>
  <ng-container *ngIf="(!uPlayerPurchased && video?.subtitle) || movie?.releaseMessage">
    <div class="subtitle status bold line">
      <span [innerHTML]="video?.subtitle || movie?.releaseMessage | safe: 'html'"></span>
    </div>
  </ng-container>
</ng-template>

<ng-template #readMore let-type="type">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="1">
      <div class="page-content load-more-movie-detail-wrapper">
        <div [class]="'load-more-movie-detail type-1 pos-' + seeMorePos" (click)="handleSeeMore()">
          <p i18n="@@movie.cta.all" data-translate="movie.cta.all">All</p>
          <i class="pi pi-arrow-down"></i>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="2">
      <div [class]="'load-more-movie-detail type-2 pos-' + seeMorePos" (click)="handleSeeMore()">
        <ng-content *ngTemplateOutlet="iconPlayTemplate"></ng-content>
        <p i18n="@@movie.cta.all" data-translate="movie.cta.all">All</p>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="3">
      <div [class]="'load-more-movie-detail type-3 pos-' + seeMorePos" (click)="handleSeeMore()">
        <p i18n="@@movie.cta.all" data-translate="movie.cta.all">All</p>
        <ng-content *ngTemplateOutlet="iconPlayTemplate"></ng-content>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="4">
      <div [class]="'load-more-movie-detail type-4 pos-' + seeMorePos" (click)="handleSeeMore()">
        <p i18n="@@movie.cta.all" data-translate="movie.cta.all">All</p>
        <i class="pi pi-angle-down" style="font-size: 40px"></i>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #playPauseButtons>
  <ng-container *ngIf="(!active || !embedControls) && !shouldUseCenteredYoutubePlayButton">
    <div class="play-pause-buttons" [class.playing]="playingVideo">
      <!-- play button active -->
      <ng-container *ngIf="playingVideo">
        <fa-icon (click)="pause()" [icon]="faPause"></fa-icon>
      </ng-container>
      <!-- play button inactive -->
      <ng-container *ngIf="!playingVideo">
        <div class="play" (click)="requestPlayTrailer()">
          <ng-content *ngTemplateOutlet="iconPlayTemplate"></ng-content>
          <span>{{ trailerOrPlayLabel }}</span>
        </div>
      </ng-container>
      <!-- mute button muted -->
      <ng-container *ngIf="mute">
        <fa-icon (click)="toggleMute(false)" class="mute" [icon]="faMute"></fa-icon>
      </ng-container>
      <!-- mute button unmuted -->
      <ng-container *ngIf="!mute">
        <fa-icon (click)="toggleMute(true)" class="mute" [icon]="faVolumeUp"></fa-icon>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #competitionsCtaTemplate>
  <div class="competitions-button-container" [ngClass]="{ hideCompetitions: hideCompetitionBtn }">
    <div class="competitions-wrapper">
      <a
        class="competitions-button"
        (click)="competitionSelected()"
        [routerLink]="competitionLink"
        [queryParams]="competitionQParams"
      >
        <ng-container *ngIf="competitionContent; else competitionDefaultBannerContent">
          <div [innerHTML]="competitionContent"></div>
        </ng-container>
      </a>
      <fa-icon [icon]="faTimes" (click)="hideCompetitionBtn = true"></fa-icon>
    </div>
  </div>
</ng-template>

<ng-template #competitionDefaultBannerContent>
  <ng-container i18n="@@video-thumbnail.competition">Competition</ng-container>
  <span class="highlight">{{ movie?.title }}</span>
</ng-template>

<ng-template #iconPlayTemplate>
  <fa-icon [icon]="faPlay" *ngIf="!iconPlay"></fa-icon>
  <!-- iconPlay?.url not working -->
  <img
    class="play-icon-svg"
    *ngIf="iconPlay"
    [src]="'assets/icons/' + iconPlay.src"
    [height]="iconPlay?.height"
    [width]="iconPlay?.width"
  />
</ng-template>
